




























import { Vue, Component } from 'vue-property-decorator';
import MainNav from '@/components/layout/MainNav.vue';

// 左边栏
@Component({ components: { MainNav } })
export default class MainSideBar extends Vue {
  public width = 256;
  public mini = false;
  public expandOnHover = false;

  public get expandIcon() {
    return 'mdi-dots-vertical';
  }

  public miniChange(value: boolean) {
    this.width = this.expandOnHover && value ? 80 : 256;
  }
}
